$shm_hitalama_profile_page $mol_page
	title \Личный кабинет
	profiles $shm_hitalama_profile_dict
	message_login_empty \Логин не может быть пустым
	message_login_exists \Пользователь "{login}" уже существует
	message_saved \Сохранено
	body /
		<= Login_label $mol_labeler
			title \Имя
			content /
				<= Login $mol_string
					value? <=> login? \
					submit? <=> save? null
		<= Login_tools $mol_view
			sub /
				<= Save $mol_button_major
					title \Сохранить
					click? <=> save? null
					enabled? <=> save_enabled? true
				<= Exit $mol_button_minor
					title \Выйти
					click? <=> exit? null
		<= Secret_label $mol_labeler
			title \Секретный ключ
			content /
				<= Secret_copy $mol_button_copy
					title \Скопировать секретный ключ
					text <= secret_key \
		<= Message $mol_text text <= message? \
